export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/1.jpg'),
        title: '企業戦略と変革',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '業務効率の向上・運用コスト削減',
      description: `<p style="font-size:1.05rem">ビジネストランスフォーメーションは、組織と従業員を企業の戦略とビジョンにより近づけるための戦略的変革です。これはモダナイゼーション計画の重要な要素であり、競争が激化するグローバル市場で生き残るために不可欠です。
多くの企業は成長と競争力維持、顧客ニーズ充足のためにビジネスモデルを変革しています。この変化は外的要因による場合もあり、経験豊富なパートナーの支援が必要です。
MaesInfoは豊富な経験を有し、クライアントの戦略策定とトランスフォーメーションの実行を支援します。専門知識と問題解決の技術で、戦略の効果的な実施をサポートします。</p>`
    },
    {
      title: 'MaesInfoが貴社をどのように支援するか',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/2.jpg')+`)"></span>
      <span class="list">
      <i></i>製品と市場の分析による機会の最大化<br/>
      <i></i>市場機会の特定と戦略的活用<br/>
      <i></i>企業計画の策定<br/>
      <i></i>事業部門の戦略設計<br/>
      <i></i>ポートフォリオ戦略の構築<br/>
      <i></i>成長戦略の立案<br/>
      <i></i>イノベーション、多角化と商業化支援<br/>
      <i></i>臨床研究戦略（該当分野向け）<br/>
      <i></i>無機的成長戦略の支援
      </span>`
    }
  ]
}
